import { FilterField } from "~/features/filter";

import { useDealersOptions } from "./optionsHooks";

type Translate = (key: string) => string;

/** Все ключи URL, которыми владеет фильтр. */
export const LIST_OF_DOCUMENTS_FILTER_KEYS = [
  "dealers",
  "contractNumber",
  "dateFrom",
  "dateTo",
];

/**
 * Поля фильтра реестра документов. Имена полей совпадают с URL-параметрами —
 * значения фильтра хранятся в query-строке, а переменные запроса списка
 * собираются из них во вкладках Contracts/Agreements.
 */
export const listOfDocumentsFilterFields = (t: Translate): FilterField[] => [
  {
    name: "dealers",
    type: "select",
    multiple: true,
    label: t("registryOfDocs.dealers"),
    optionsHook: useDealersOptions,
  },
  {
    name: "contractNumber",
    type: "input",
    label: t("registryOfDocs.contractNumber"),
  },
  {
    name: "dateFrom",
    type: "dateRange",
    nameTo: "dateTo",
    label: t("registryOfDocs.contractDate"),
  },
];
